import { render, staticRenderFns } from "./ConfigurarPantallaMotivo.vue?vue&type=template&id=62789b2d&"
import script from "./ConfigurarPantallaMotivo.vue?vue&type=script&lang=ts&"
export * from "./ConfigurarPantallaMotivo.vue?vue&type=script&lang=ts&"
import style0 from "./ConfigurarPantallaMotivo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports